<template>
  <div class="wrapper-page">
    <el-card class="box-card">
      <template #header>
        <div class="card-header">
          <span>重置密码</span>
        </div>
      </template>

      <el-form ref="form" :model="form" label-width="100px" status-icon>
        <el-form-item
          label="手机号码"
          prop="mobile"
          :rules="[
            { required: true, message: '请输入手机号码' },
            { validator: validateMobile, message: '请输入有效的手机号码' },
          ]"
        >
          <el-input v-model="form.mobile" placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item label="短信验证码" prop="code" :rules="[{ required: true, message: '请输入短信验证码' }]">
          <el-input v-model="form.code" autocomplete="off" placeholder="请输入短信验证码">
            <template #append>
              <el-link :underline="false" @click.prevent="btnSendSmsClick">
                {{ countdown > 0 ? countdown + '秒' : '获取验证码' }}
              </el-link>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="password" :rules="[{ required: true, message: '请输入新密码' }]">
          <el-input v-model="form.password" type="password" name="password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
          label="确认密码"
          prop="confirmPassword"
          :rules="[{ required: true, message: '请输入确认密码' }, { validator: validatePass }]"
        >
          <el-input v-model="form.confirmPassword" type="password" name="confirmPassword" autocomplete="off"></el-input>
        </el-form-item>

        <el-divider></el-divider>
        <div style="height: 10px"></div>
        <el-form-item align="center">
          <el-button type="primary" @click="btnSubmitClick">确 定</el-button>
          <el-link @click.prevent="btnLoginClick" icon="el-icon-user" type="primary" :underline="false" style="margin-left: 10px">
            返回登录
          </el-link>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script lang="ts">
import utils from '@/utils';
import { defineComponent } from 'vue';
import api from '@/api/lostPassword';
import { IElForm } from '@/types/element';

export default defineComponent({
  data() {
    return {
      form: {
        mobile: '',
        code: '',
        password: '',
        confirmPassword: '',
      },
      countdown: 0,
      validateMobile: utils.validateMobile,
    };
  },
  methods: {
    apiSendSms() {
      api.sendSms(
        {
          mobile: this.form.mobile,
        },
        (res) => {
          if (!res.value) return;

          utils.notifySuccess('验证码发送成功，10分钟内有效');
          this.countdown = 60;
          const interval = setInterval(() => {
            this.countdown -= 1;
            if (this.countdown <= 0) {
              clearInterval(interval);
            }
          }, 1000);
        },
      );
    },

    apiSubmit() {
      api.submit(
        {
          mobile: this.form.mobile,
          code: this.form.code,
          password: this.form.password,
        },
        (res) => {
          if (!res.value) return;

          utils.alertSuccess(
            {
              title: '恭喜，密码重置成功',
              button: '进入登录页',
            },
            () => {
              utils.pageOpen('/login');
            },
          );
        },
      );
    },

    isMobile(value: string) {
      return utils.isMobile(value);
    },

    btnSendSmsClick() {
      if (this.countdown > 0) return;
      if (!this.form.mobile) {
        utils.notifyError('手机号码不能为空');
        return;
      }
      if (!this.isMobile(this.form.mobile)) {
        utils.notifyError('请输入有效的手机号码');
        return;
      }

      this.apiSendSms();
    },

    btnLoginClick() {
      utils.pageOpen('/login');
    },

    btnSubmitClick() {
      (this.$refs.form as IElForm).validate((valid) => {
        if (valid) {
          this.apiSubmit();
        }
      });
    },

    validatePass(rule: unknown, value: string, callback: (error?: Error) => void) {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    },
  },
  mounted() {
    utils.loading(false);
  },
});
</script>

<style scoped>
.wrapper-page {
  margin: 7.5% auto;
  max-width: 460px;
}
</style>
